import React from "react";
import ProtectedRouteByCompanyDetails from "./ProtectedRouteByCompanyDetails";
import ProtectedRouteByYear from "./ProtectedRouteByYear";

const DynamicProtectedRoute = ({ children, protections }) => {
  let wrappedChildren = children;

  // Apply protections in reverse order (innermost first)
  if (protections.includes("year")) {
    wrappedChildren = <ProtectedRouteByYear>{wrappedChildren}</ProtectedRouteByYear>;
  }
  if (protections.includes("companyDetails")) {
    wrappedChildren = (
      <ProtectedRouteByCompanyDetails>{wrappedChildren}</ProtectedRouteByCompanyDetails>
    );
  }

  return wrappedChildren;
};

export default DynamicProtectedRoute;